import getDestinationIcon from "helpers/destinations/getDestinationIcon";
import {
    getDestinationIcon as getLeadDestinationIcon,
    getSourceIcon as getLeadSourceIcon,
} from "helpers/leads/icon";

import { getSourceTypeOptions } from "components/organisms/SourceCreation/SourceCreation.helpers";

// components/organisms/SourceCreation/SourceCreation.helpers
const SOURCE_TYPE_CODES = [
    "js",
    "redirect",
    "capi",
    "ftp",
    "dynamics",
    "sftp",
    "zoho",
    "salesforce",
    "hub",
    "monday",
    "zendesk_sell",
    "pipe",
    "b24",
    "bigquery",
    "freshsales",
    "upload",
    "spreadsheet",
    "vtiger",
    "odoo",
    "lsqrd",
    "appsflyer",
    "adjust",
    "androidcapi",
    "ioscapi",
    "msg",
];

// helpers/destinations/getDestinationIcon
const DESTINATION_TYPE_CODES = [
    "fbpixel",
    "fbcapi",
    "fboffline",
    "fbca",
    "alpixel",
    "ttpixel",
    "ttcapi",
    "ttoffline",
    "ttca",
    "ttapp",
    "ttmessaging",
    "scpixel",
    "sccapi",
    "pnpixel",
    "pncapi",
    "ggads",
    "ggads_web",
    "ggads4",
    "twcapi",
    "twpixel",
    "rdcapi",
    "rdpixel",
    "imcapi",
    "sstask",
    "ggbq",
    "licapi",
    "msoffline",
    "ymwc",
    "lnpixel",
    "lncapi",
    "oaipixel",
    "oaicapi",
];

// helpers/leads/icon
const LEAD_SOURCE_CODES = ["fl", "sapi", "tiktok", "gglw", "lnkdn"];

// helpers/leads/icon
const LEAD_DESTINATION_CODES = [
    "http",
    "zoho",
    "salesforce",
    "microsoft-dynamics",
    "high-level",
    "sugar-crm",
    "odoo",
    "perfex",
    "fresh-sales",
    "vtiger",
    "wati",
    "monday",
    "hubspot",
    "zendesk",
    "b24",
    "bigquery",
    "google-sheets",
];

const UNSHARED_ICONS = [
    "/assets/images/typeImages/zoho.png",
    "/assets/images/androidcapi.png",
    "/assets/images/ioscapi.png",
    "/assets/images/windows.png",
];

const OVERSIZED_ICONS = new Set([
    "/assets/images/typeImages/messaging.png", // 607 KB
    "/assets/images/typeImages/bigquery.png", // 549 KB
    "/assets/images/typeImages/sstask.png", // 150 KB
]);

/**
 * @type {Array<string>}
 */
export const PREFETCH_ICON_PATHS = [
    ...new Set([
        ...getSourceTypeOptions(
            SOURCE_TYPE_CODES.map((code) => ({ code })),
        ).map((option) => option?.image),
        ...DESTINATION_TYPE_CODES.map((code) => getDestinationIcon(code)),
        ...LEAD_SOURCE_CODES.map((code) => getLeadSourceIcon(code)),
        ...LEAD_DESTINATION_CODES.map((code) => getLeadDestinationIcon(code)),
        ...UNSHARED_ICONS,
    ]),
].filter((path) => path && !OVERSIZED_ICONS.has(path));

export default PREFETCH_ICON_PATHS;
